@if (displayCount) {
	<div class="unread-counter">
		<span>{{ displayCount }}</span>
	</div>
}
